/**
 * @flow
 * @format
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import * as moment from 'moment';
import * as Constants from '../../constants/globals';
import 'moment/locale/fr';

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // have a common namespace used around the full app

    debug: false, // !Constants.production,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    // react-i18next options
    react: {
      useSuspense: true,
    },
  });
moment.locale(i18n.language);

export function changeLocale(locale: string) {
  if (Constants.enableHelperLogger) console.log(`Locale changed to '${locale}'`);
  i18n.changeLanguage(locale);
  moment.locale(locale);
}

export { i18n, moment };
